import { render, staticRenderFns } from "./MunicionesArmaDialogComponent.vue?vue&type=template&id=0890bbff"
import script from "./MunicionesArmaDialogComponent.vue?vue&type=script&lang=js"
export * from "./MunicionesArmaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports